angular.module('impactx.rfx').controller('RFXSupplierViewCtrl', RFXSupplierViewCtrl);
RFXSupplierViewCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToolbarService',
    'BackService',
    'ToastService',
    '$redirect',
    'WarningService',
    'TranslationService',
    'RFXSupplierService',
    'LoadingDialogService',
    'DownloadService',
    '$mdDialog'
];

function RFXSupplierViewCtrl($scope, dataGen, $routeParams, ToolbarService, BackService, ToastService, $redirect, WarningService,
                             TranslationService, RFXSupplierService, LoadingDialogService, DownloadService, $mdDialog) {
    var self = this;

    var getData = function () {
        LoadingDialogService.start();
        dataGen.getData($scope, {id: $routeParams.id}, "/rfx/supplier/view").then(function () {
            LoadingDialogService.stop();
            $scope.setButtons();
            if ($scope.data.infoMessages.length > 0) {
                WarningService.showWarningDialog(null, null, TranslationService.get('warning'), null, TranslationService.get('ok'), $scope.data.infoMessages, null, true);
            }
        }, LoadingDialogService.stop);
    };
    getData();

    $scope.setButtons = function () {
        $scope.buttonDefinition = [
            {
                label: $scope.trns.edit,
                action: $scope.makeOffer,
                type: 'dialogaction',
                condition: canMakeOffer
            },
            {
                label: $scope.trns.edit,
                action: $scope.reworkRequest,
                type: 'dialogaction',
                condition: canRework
            },
            {
                label: $scope.trns.viewOffer,
                linkFunction: self.getDetailLink,
                type: 'link',
                process: 'RFXSupplierView',
                condition: canViewOffer
            },
            {
                label: $scope.trns.conversations,
                linkFunction: self.getConversationsLink,
                type: 'link',
                process: 'RFXThreadSupplierList',
                condition: allowConversations
            },
            {
                label: $scope.trns.cancelRequest,
                action: $scope.cancelRequest,
                type: 'dialogaction',
                condition: canCancelRequest
            }
        ];

        ToolbarService.setButtons($scope.buttonDefinition);
    };

    self.getDetailLink = function () {
        return 'rfxsupplier/edit/' + $scope.data.id;
    };

    self.getConversationsLink = function () {
        return 'rfxthread/supplier/' + $scope.data.headerId + "/"+ $scope.data.supplierId;
    };

    self.downloadAttachment = function (media) {
        DownloadService.openDownloadPost('/rfx/download/media', {paramName: "id", paramValue: media.id});
    };

    $scope.cancelRequest = function () {
        LoadingDialogService.start();
        return RFXSupplierService.cancelRequest($scope.data).then(function () {
            LoadingDialogService.stop();
            $redirect.redirectTo(null, "/rfxsupplierlist")
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        }, LoadingDialogService.stop);
    };

    $scope.makeOffer = function () {
        var dataObj = {
            data: $scope.data
        };
        LoadingDialogService.start();
        return dataGen.postAsForm({}, dataObj, "/rfx/supplier/cancreate").then(function () {
            // LoadingDialogService.stop(); is called after redirect
            $redirect.redirectTo(null, self.getDetailLink());
        }, LoadingDialogService.stop);
    }

    $scope.reworkRequest = function () {
        var dataObj = {
            data: $scope.data
        };
        LoadingDialogService.start();
        return dataGen.postAsForm({}, dataObj, "/rfx/supplier/rework").then(function () {
            // LoadingDialogService.stop(); is called after redirect
            $redirect.redirectTo(null, self.getDetailLink());
        }, LoadingDialogService.stop);
    }

    function canMakeOffer() {
        return $scope.data.canReply && !canViewOffer();
    }

    function canViewOffer() {
        return $scope.data.canViewOffer;
    }

    var canCancelRequest = function () {
        return $scope.data.canCancel;
    };

    function canRework() {
        return $scope.data.canRework && !$scope.data.canReply && !canViewOffer();
    }

    function allowConversations() {
        return $scope.data.allowConversations;
    }

    this.redirectToNewConversation = function(event) {
        $redirect.redirectTo(null, '/rfxthread/edit/supplier/0/' + $scope.data.headerId + '/true');
    };
}